module.exports = __webpack_public_path__ + "img/image_18.9d6e408a.png";